// extracted by mini-css-extract-plugin
module.exports = {"container":"loading-screen_container__3n6yX","imageWrapper":"loading-screen_imageWrapper__3xaRa"};